<!-- =========================================================================================
  File Name: AttendeeAdd.vue
  Description: Attendee Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
.header-custome{margin-bottom: 15px;padding-left: 2px;}
.attendee-form-wrap .con-slot-tabs {
    padding: 0 200px;
}
@media screen and (min-width:1367px) and (max-width: 1440px){
.attendee-form-wrap .con-slot-tabs {
    padding: 0 0px;
}
}
@media screen and (max-width:1366px) {
.attendee-form-wrap .con-slot-tabs {
    padding: 0 0px;
}
}
</style>
<template>
  <div id="page-attendee-add" class="attendee-form-wrap">
    <div class="header-custome">
      <h3>Add Round Table</h3>
    </div>
    <vx-card v-if="roundtable_data">

      <div slot="no-body" class="tabs-container px-6 pt-6">

        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          
            <div class="tab-text">
              <roundtable-edit-tab-account class="mt-4" :data="roundtable_data" />
            </div>

          
        </vs-tabs>

      </div>

    </vx-card>
  </div>
</template>

<script>
import roundtableEditTabAccount     from './RoundtableEditTabAccount.vue'

// Store Module
import moduleroundtableManagementAdd from '@/store/roundtable-management/moduleRoundtableManagement.js'

export default {
  components: {
    roundtableEditTabAccount
    //attendeeEditTabInformation,
  },
  data () {
    return {
      roundtable_data: null,
      roundtable_not_found: false,

      /*
        This property is created for fetching latest data from API when tab is changed

        Please check it's watcher
      */
      activeTab: 0
    }
  },
  watch: {
    activeTab () {
      this.fetch_roundtable_data()
    }
  },
  methods: {
    fetch_roundtable_data () {
      this.$store.dispatch('roundtableManagement/fetchRoundTable', null)
        .then(res => { this.roundtable_data = res.data })
        .catch(err => {          
          console.error(err) 
        })
    }
    
  },
  created () {
    // Register Module roundtableManagement Module
    if (!moduleroundtableManagementAdd.isRegistered) {
      this.$store.registerModule('roundtableManagement', moduleroundtableManagementAdd)
      moduleroundtableManagementAdd.isRegistered = true
    }    
    this.fetch_roundtable_data()
  }
}

</script>